var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyleGuidesIcon = function SvgStyleGuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M22.857 0H5.714C2.558 0 0 2.388 0 5.333v37.334C0 45.612 2.558 48 5.714 48h28.572C37.442 48 40 45.612 40 42.667V16L22.857 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M22.855 16V0l17.143 16H22.856Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.572 26.667C8.572 25.194 9.85 24 11.429 24h17.143c1.578 0 2.857 1.194 2.857 2.667 0 1.473-1.28 2.667-2.857 2.667H11.429c-1.578 0-2.857-1.194-2.857-2.667ZM8.572 37.333c0-1.472 1.279-2.666 2.857-2.666h17.143c1.578 0 2.857 1.194 2.857 2.666 0 1.473-1.28 2.667-2.857 2.667H11.429c-1.578 0-2.857-1.194-2.857-2.667Z"
  })));
};
export default SvgStyleGuidesIcon;